<script>
    import { groups_fi, groups_en, groupIcons, pageTitles_fi, pageTitles_en, tresh1, tresh2, tresh3 } from "../scripts/questions";
    import { lang } from "../scripts/stores";

    export let scores;
    export let index = 0;
    export let show = true;

    let groups = $lang === "fi" ? groups_fi : groups_en;
    let pageTitles = $lang === "fi" ? pageTitles_fi : pageTitles_en;

    $: if($lang) {
        groups = $lang === "fi" ? groups_fi : groups_en;
        pageTitles = $lang === "fi" ? pageTitles_fi : pageTitles_en;
    }

    function getColor(value) {
        const type = "turn";
        value = value / 100;

        if(type === "turn") { 
            value = 1 - value;

            if(value <= tresh1) return "rgb(255, 51, 51)";
            else if(value > tresh1 && value < tresh2) return "rgb(255, 170, 51)";
            else if(value >= tresh2) return "rgb(255, 235, 0)";
        }
    }

</script>

<style>
     .category-info {
        max-width: 960px;
        margin: 0 auto 2rem auto;
        padding: 1rem;
        /* margin-bottom: 2rem; */
        border: 1px solid gray;
        border-radius: 6px;
    }
    .title-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .title-container .expand {
        font-size: 38px;
        cursor: pointer;
    }
    .title-container h3 {
        margin-bottom: 0 !important;
    }
    h3 .material-icons { 
        vertical-align: middle;
        margin-right: .5rem;
    }
    .category-info ul { 
        margin-left: 1.5rem;
        margin-top: 2rem;
    }
    .category-info li {
        display: flex;
        justify-content: flex-start;
        align-items: baseline;
        margin-bottom: .5rem;
    }
    .ball {
        margin-right: 1rem;
        height: .75rem;
        width: .75rem;
        min-width: 0.75rem;
        border-radius: 50%;
        background: red;
    }
    .link-container {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        margin-bottom: 0;
        margin-top: 1rem;
    }
    .basic-link {
        margin-left: 1rem;
    }
    .basic-link, .basic-link:visited, .basic-link:active {
        color: #570df8
    }
    .category-link { 
        display: block;
        margin-top: 1rem;
        margin-bottom: .5rem; 
        margin-right: 1rem;
        font-weight: 500;
    }
    .category-link, .category-link:visited { color: #570df8; }
    .category-link:hover {
        font-weight: 600;
        transition: .1s;
    }
    .category-link .material-icons {
        line-height: 27px;
        vertical-align: text-top;
    }
    @media screen and (max-width: 542px) {
        .category-link { margin-right: 0; }
    }
</style>

<div data-category={index} class="category-info">
    <div class="title-container">
        <h3 on:click={ () => show = !show }>
            <i class="material-icons"> { groupIcons[index] } </i>
            { groups[index] }
        </h3>

        <i class="material-icons expand" on:click={ () => show = !show }>
            {!show ? "expand_less" : "expand_more"}
        </i>
    </div>

    {#if show}
    <div>
        {#if scores.length === 0}
            <p style="margin-top: 1rem; font-weight: 500;">
                { $lang === "fi" ? "Ei näytettäviä kohteita" : "Nothing to display" }
            </p>   
        {/if}
        <ul>
            {#each scores as score}
                {#if score.type === 0}
                    <li>
                        <div class="ball" style="background: { getColor(score.value) }"></div>             
                        <div>
                            {#if !score.isFull} 
                                { pageTitles[score.page - 1].replace("...", "") } 
                                { score.title.toLowerCase() }
                            {:else}
                                { score.title }
                            {/if}

                            <i style="text-decoration: underline; font-size: .8rem;">{ score.value }/100</i>

                            
                            {#if score.details}
                                <div style="margin-top: 1rem;">
                                    <b>{ $lang === "fi" ? "Muistiinpanot" : "Notes" }</b>
                                    <br />
                                    { score.details }
                                </div>
                            {/if}
                        </div>
                    </li>    
                {/if}                    
            {/each}
        </ul>
        <a href="/#/answers/{index}" class="basic-link">
            { $lang === "fi" ? "Katso kaikki..." : "See all answers..." }
        </a>

        <div class="link-container">
            <a href="/#/info/{index}" class="category-link">
                <i class="material-icons">help</i>
                { $lang === "fi" ? "Vinkkejä aistiesteettömyyden parantamiseksi" : "Tips for improving sensory accessibility" }
            </a>
        </div>
    </div>
    {/if}
</div> 